import React from 'react';

import Login from '../Login/Login';

const EmailLookup = () => <Login path="/email-lookup" />;

export default EmailLookup;
